import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import './simTypographyStyles.css';

const SimTypography = ({ children, variant, ...rest }) => {
	return (
		<Box>
			<Typography variant={variant} {...rest}>
				{['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'buttonText'].includes(variant) ? (
					<Box className='font-face-itim-regular'>{children}</Box>
				) : variant === 'menuRootText' ? (
					<Box className='font-face-itim-regular' sx={{ fontSize: 18 }}>
						{children}
					</Box>
				) : variant === 'light' ? (
					<Box className='font-face-roboto-light'>{children}</Box>
				) : (
					<Box className='font-face-roboto-regular'>{children}</Box>
				)}
			</Typography>
		</Box>
	);
};

SimTypography.propTypes = {
	children: PropTypes.node.isRequired,
	variant: PropTypes.string.isRequired
};

export { SimTypography };


